export enum GenericTooltips {
    New     = "New",
    Active  = "In Progress",
    Closed  = "Closed",
    Resolved  = "Resolved",
    Removed = "Cancelled",
}
